var exports = {
  "iE": "wrapper__09pFKw",
  "Iq": "stackWrapper__NuuylZ",
  "qr": "footer__SzZCB7",
  "ZI": "legalDisclaimer__Nj3K07",
};

module.exports = exports;
